export default __webpack_public_path__ + "static/media/ba.43bcce38.svg";